import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../../Utils/toastContext";
import AddUserPopup from "../../../Components/add-joint-accounts/Add-User-Popup";
import { useDispatch, useSelector } from "react-redux";
import {
  setAccountTypeId,
  setApplicantCountry,
} from "../../../Redux/store/accountTypeSlice";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import AddressAutocomplete from "../../../Components/addressInput/address-input";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDropdownWithFetch from "../../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import { debounce } from "lodash";
import countriesData from "../../../Data/CountryCodes.json";

const PersonalInfo = ({ setCurrentStep }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const applicationType = useSelector(
    (state) => state.accountType.applicationType
  );
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [accountType, setAccountType] = useState(null);
  const [jointAccountUser, setJointAccountUser] = useState("");
  const [accountTypeLabel, setAccountTypeLabel] = useState("");
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [advisorId, setAdvisorId] = useState("");
  const [isAdvisorExist, setIsAdvisorExist] = useState(false);
  const [advisorName, setAdvisorName] = useState("");
  const [fullName, setfullName] = useState("");
  const [profilePayloadFile, setProfilePayloadFile] = useState("");

  const [firstName, setfirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [formerNames, setFormerNames] = useState([]);
  const [accountTypeData, setAccountTypeData] = useState([]);
  const [newFormerName, setFormerName] = useState("");
  const [Dob, setDob] = useState("");
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const [currencyData, setCurrencyData] = useState([]);
  const [expectedAmountData, setExpectedAmountData] = useState([]);
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({});
  const [preselectedAccountType, setpreselectedAccountType] = useState({});
  const [toCurrency, setToCurrency] = useState(2);
  const [capturedFile, setCapturedFile] = useState(null);

  const [toCurrencyText, setToCurrencyText] = useState("AUD");
  const [jointAccountUserLabel, setJointAccountUserLabel] = useState("");

  const [countryCodeData, setCountryCodeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 14,
    label: "Australia",
  });
  const [preselectedJointAccountUser, setPreselectedJointAccountUser] =
    useState({});
  const [countryCode, setCountryCode] = useState(14);
  const [redCountry, setRedCountry] = useState(null);
  const [countryCodeText, setCountryCodeText] = useState("Australia");
  const [redAddress, setRedAddress] = useState("");
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [investmentAmountText, setInvestmentAmountText] = useState(null);
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState("/avatar.svg");
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [fileAvailable, setFileAvailable] = useState(false);
  const [fileAttorneyPath, setfileAttorneyPath] = useState("");

  const [stream, setStream] = useState(null);
  const [animateCamera, setAnimateCamera] = useState(false);
  const { showToast } = useToast();
  const [jointAccountId, setJointAccountId] = useState(null);
  const [isCheckedSecond, setIsCheckedSecond] = useState(false);
  const [members, setMembers] = useState([]);
  const [signatory, setSignatory] = useState("no");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [actualData, setactualData] = useState([]);
  const [jointAccountUsersData, setJointAccountUsersData] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const containerRef = useRef(null);
  const [nameFromBirth, setNameFromBirth] = useState("yes");
  const clientIdRedux = useSelector((state) => state.user.clientId);
  const [clientId, setClientId] = useState(clientIdRedux);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAllStates = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/states/${redCountry}?size=200000`
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.states.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setStateData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setStateData([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCities = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/cities/${redCountry}?size=200000`
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.cities.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setCityData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setStateData([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAccountTypes = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/user-types/${applicationType}/accounts`
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setAccountTypeData(AccountData);
        setpreselectedAccountType(AccountData[0]);
        setAccountType(AccountData[0].value);
        setAccountTypeLabel(AccountData[0].label);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountTypeData([]);
          setpreselectedAccountType({});
          setAccountType(null);
          setAccountTypeLabel("");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setAccountTypeData([]);
      setpreselectedAccountType({});
      setAccountType(null);
      setAccountTypeLabel("");
    } finally {
    }
  };
  const getInvestmentAmount = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/personal-information/expected-investment-amounts`
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.expected_investment_amounts.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setExpectedAmountData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountTypeData([]);
          setpreselectedAccountType({});
          setAccountType(null);
          setAccountTypeLabel("");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setAccountTypeData([]);
      setpreselectedAccountType({});
      setAccountType(null);
      setAccountTypeLabel("");
    } finally {
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            symbol: profile.symbol,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/countries?size=250`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/countries?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
    const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/personal-information/individual/preview`
      );

      if (response.status == 200) {
        setAccountType(response.data.account_type.id);
        setAccountTypeLabel(response.data.account_type.name);
        setpreselectedAccountType({
          value:response.data.account_type.id,
          label:response.data.account_type.name
        });
        setfirstName(response.data.first_name);
        setLastName(response.data.last_name);
        setMiddleName(response.data.middle_name);
        setNameFromBirth(response.data.is_birth_name==true?"yes":"no");
        setFormerName(response.data.former_names);
        setDob(response.data.date_of_birth);
        setCountryCode(response.data.applicant_country);
        let appCountry=countryCodeData.filter(item=>item.value==response.data.applicant_country)
        setCountryCodeText(appCountry[0].label);
        setpreselectedCountryCode({
          value:response.data.applicant_country,
          label:appCountry[0].label
        })
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleNameFromBirth = (e) => {
    setNameFromBirth(e.target.value);
  };
  const handleDeleteFile = () => {
    setFileAttorney(null);
    setFileAvailable(false);
    setfileAttorneyPath("");
  };
  const addMember = () => {
    // setisUserPopOpen(true);
    setMembers([
      ...members,
      {
        firstName: "",
        lastName: "",
        dob: "",
        email: "",
        countryCode: "AU(+61)",
        mobile: "",
        address: "",
        accountType: "individual",
        errors: {
          email: "",
          mobile: "",
        },
      },
    ]);
  };

  const removeMember = (index) => {
    const updated = members.filter((_, i) => i !== index);
    setMembers(updated);
  };
  const handleContinue = () => {
    // your logic like setCurrentStep(2), API calls, etc.
    if (!firstName) {
      showToast("Please enter valid first name", "error");
      return;
    }
    if (!lastName) {
      showToast("Please enter valid last name", "error");
      return;
    }
    if (!redAddress || !redCountry) {
      showToast("Please enter valid residential address", "error");
      return;
    }
    if (!Dob) {
      showToast("Please enter valid date of birth", "error");
      return;
    }
    if (!investmentAmountText) {
      showToast("Please select expected investment amount", "error");
      return;
    }
     if (!countryCode) {
      showToast("Please select country", "error");
      return;
    }
    if (nameFromBirth === "no" && formerNames.length == 0) {
      showToast("Please enter atleast one former name", "error");
      return;
    }
    if (
      accountType != 1 &&
      accountType != 5 &&
      (members.length === 0 ||
        (members.length > 0 &&
          members[0].firstName === "" &&
          members[0].lastName === "" &&
          members[0].email === ""))
    ) {
      showToast("Please add atleast one joint account member", "error");
      return;
    }
    if (
      accountType != 1 &&
      accountType != 5 &&
      signatory == "yes" &&
      !fileAttorneyPath
    ) {
      showToast("Please upload Power of Attorney file", "error");
      return;
    }
    if (
      accountType != 1 &&
      accountType != 5 &&
      signatory == "yes" &&
      !jointAccountUser
    ) {
      showToast("Please select sole signatory", "error");
      return;
    }
    setLoading(true)
    handlesave();
  };
  const updateMember = (index, key, value, newErrors = null) => {
    setMembers((prev) =>
      prev.map((member, i) =>
        i === index
          ? {
              ...member,
              [key]: value,
              errors: newErrors !== null ? newErrors : member.errors,
            }
          : member
      )
    );
  };
  const handleSelectAccountType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setAccountType(selectedOption.value);
    setAccountTypeLabel(selectedOption.label);
  };
  const handleSelectJointAccountUser = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setJointAccountUser(selectedOption.value);
    setJointAccountUserLabel(selectedOption.label);
  };
  const handleSelectInvestmentAmount = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setInvestmentAmount(selectedOption.value);
    setInvestmentAmountText(selectedOption.label);
  };
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setRefNumber(pasteData.split(""));
    }
    event.preventDefault();
  };
  const handleUploadFile = useCallback(
    debounce(async (e, file) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UploadCSVApi(capturedFile);
        if (response.status == "200") {
          toastMessage = {
            message: "Profile picture uploaded successfully",
            type: "success",
          };
          handleCloseCamera();
          setProfilePayloadFile(response.data.profile_image_url);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [capturedFile] // Dependencies
  );
  const handleChange = (value, index) => {
    setIsAdvisorExist(false);
    setAdvisorName("");
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...refNumber];
      newOtp[index] = value;
      setRefNumber(newOtp);
      if (value && index < 6) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !refNumber[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  const handleAddFormerName = (e) => {
    if (e.key === "Enter" && newFormerName.trim() !== "") {
      setFormerNames([...formerNames, newFormerName.trim()]);
      setFormerName("");
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames(formerNames.filter((_, index) => index !== indexToRemove));
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
    setToCurrencyText(selectedOption.label);
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
    setCountryCodeText(selectedOption.label);
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await UploadCSVApi(file);
        if (response.status == "200") {
          toastMessage = {
            message: "Profile picture uploaded successfully",
            type: "success",
          };
          const imageUrl = URL.createObjectURL(file);
          setPreview(imageUrl);
          setProfilePayloadFile(response.data.profile_image_url);
        }
      } catch (err) {
        setPreview("/avatar.svg");
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = "";
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/onboarding/personal-information/upload/profile-image`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append("profile_image", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const startCamera = async () => {
    setPreview("/avatar.svg");
    setCapturedFile(null);
    setShowCamera(true);

    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error("Camera access error:", err);
    }
  };
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);
  useEffect(() => {
    const allAccounts = members
      .filter((m) => m?.firstName && m?.lastName && m?.email)
      .map((m) => ({
        value: m.email,
        label: `${m.firstName} ${m.lastName}`,
      }));

    if (allAccounts.length) {
      setJointAccountUsersData(allAccounts);
      setJointAccountUsersData(allAccounts);

      // Reset preselected if not in the updated list
      const isPreselectedValid = allAccounts.some(
        (acc) => acc.value === preselectedJointAccountUser?.value
      );
      if (!isPreselectedValid) {
        setPreselectedJointAccountUser({});
      }
    }
  }, [members]);
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (e) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileAttorney);
        if (response.status == 201) {
          setfileAttorneyPath(response.data.s3_path);
          setFileAvailable(true);
        } else {
          setFileAvailable(false);
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setFileAvailable(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileAttorney] // Dependencies
  );
  useEffect(() => {
    if (fileAttorney) {
      setLoading(true);
      handleUploadFileAttorney();
    }
  }, [fileAttorney]);
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");
    setPreview(dataUrl);
    // convert base64 -> file
    const file = dataURLtoFile(dataUrl, "snapshot.png");
    setCapturedFile(file); // store for API payload
    // cleanup
    //  handleCloseCamera();
  };
  // utility function to convert base64 -> File object
  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };
  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  const handleFileChangeAttorney = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAttorney(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/personal-information/individual/submit`;
    const transformed = members.map((item, index) => {
      return {
        first_name: item.firstName || "",
        last_name: item.lastName || "",
        email: item.email,
        country_code: item.countryCode,
        mobile_number: item.mobile,
        is_sole_signatory: jointAccountUser === item.email, // first member as sole signatory
        power_of_attorney_url: "",
      };
    });
    let bodyData = {
      account_type_id: accountType,
      full_name: firstName + " " + middleName + " " + lastName,
      first_name: firstName,
      last_name: lastName,

      profile_picture_url: profilePayloadFile,
      is_birth_name: nameFromBirth === "yes" ? true : false,
      former_names: formerNames,
      date_of_birth: Dob,
      applicant_country_id: countryCode,
      address: {
        address_line_1:
          redAddress.street == "" ? redAddress.full : redAddress.street,
        address_line_2: redAddress.route,
        city_id:
          cityData.find((c) => c.label === redAddress.city)?.value || null,
        state_id:
          stateData.find((c) => c.label === redAddress.state)?.value || null,
        country_id: redCountry,
        zip_code: redAddress.zip,
      },
      expected_investment_amount: investmentAmountText,
      default_currency_id: toCurrency,
      social_security_number: socialSecurityNumber,
      is_managing_member: isCheckedSecond,
      is_any_sole_signatory: signatory === "yes" ? true : false,
      joint_account_invitees: transformed,
      joint_user_account_id: jointAccountId,
      power_of_attorney_url: fileAttorneyPath,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handlesave = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        setCurrentStep(2);
        toastMessage = {
          message: response.message,
          type: "success",
        };
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
    dispatch(updateFormData({ field: "advisorRefNumber", value: refNumber }));
    dispatch(updateFormData({ field: "accountType", value: accountType }));
    dispatch(
      updateFormData({ field: "accountTypeLabel", value: accountTypeLabel })
    );

    dispatch(updateFormData({ field: "profilePic", value: preview }));
    dispatch(updateFormData({ field: "fullName", value: fullName }));
    dispatch(updateFormData({ field: "nameFromBirth", value: nameFromBirth }));
    dispatch(
      updateFormData({ field: "customerFormerNames", value: formerNames })
    );
    dispatch(updateFormData({ field: "dob", value: Dob }));
    dispatch(
      updateFormData({
        field: "expectedInvestedAmount",
        value: investmentAmountText,
      })
    );
    dispatch(updateFormData({ field: "currency", value: toCurrencyText }));
    dispatch(updateFormData({ field: "currencyId", value: toCurrency }));
    dispatch(updateFormData({ field: "address", value: redAddress }));
    dispatch(updateFormData({ field: "clientId", value: clientId }));
    dispatch(updateFormData({ field: "applicantCountry", value: countryCode }));
    dispatch(
      updateFormData({ field: "applicantCountryText", value: countryCodeText })
    );

    if (accountType != 1 && accountType != 5) {
      dispatch(
        updateFormData({ field: "jointAccountId", value: jointAccountId })
      );
      dispatch(updateFormData({ field: "jointAccountMember", value: members }));
      dispatch(updateFormData({ field: "isSignatory", value: signatory }));
      dispatch(updateFormData({ field: "fileAttorney", value: fileAttorney }));
      dispatch(
        updateFormData({ field: "jointAccountUser", value: jointAccountUser })
      );
      dispatch(
        updateFormData({
          field: "jointAccountUserLabel",
          value: jointAccountUserLabel,
        })
      );
    }
  };
  const createRefNumber = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/personal-information/verify-advisor`;
    const bodyData = {
      advisor_number: refNumber.join(""),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddRefNumber = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createRefNumber();
        if (response.status == 200) {
          setIsAdvisorExist(true);
          setAdvisorName(response.data.advisor.name);
        } else {
          setIsAdvisorExist(false);
          setAdvisorName("Advisor not found");
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        setIsAdvisorExist(false);
        setAdvisorName("Advisor not found");
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [refNumber] // Dependencies
  );
  useEffect(() => {
    getAccountTypes();
    getInvestmentAmount();
    getAllCurrency();
    getAllCountries();
    getDetails();
  }, []);
  useEffect(() => {
    if (redCountry != null) {
      getAllStates();
      getAllCities();
    }
  }, [redCountry]);
  useEffect(() => {
    if (redAddress && redAddress.country) {
      setRedCountry(
        countryCodeData.find((c) => c.label === redAddress.country)?.value ||
          null
      );
    }
  }, [redAddress]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/profile-circle-black.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Personal Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      Account Type
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={accountTypeData}
                  onSelect={handleSelectAccountType}
                  preselectedValue={preselectedAccountType}
                />
                {accountType != 1 && accountType != 5 && (
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                    Please make sure you have chosen the joint account type that
                    best fits you.
                  </p>
                )}
              </div>
              <div className="">
                <CustomDropdownWithFetch
                  label={
                    <>
                      Applicant's Country
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={countryCodeData}
                  search={true}
                  preselectedValue={preselectedCountryCode}
                  onSelect={handleSelectCountryCode}
                  colorLabel=""
                  fetchOptions={getCountries} // <-- pass fetch function, not options
                />
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col md:px-4">
              <div className="mb-2 w-full">
                <label
                  htmlFor="custodianFee"
                  className="text-left text-sm text-labelColour block w-full"
                >
                  Advisor Ref No
                </label>
                <p className="text-[#868686] text-xs mt-1 w-full break-words leading-snug">
                  Please enter the advisor reference number if you have been
                  provided with one.
                </p>
              </div>

              <div className="flex w-full flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
                {/* Input Fields */}
                <div
                  onPaste={handlePaste}
                  className="flex mb-2 justify-center flex-wrap gap-2"
                >
                  {refNumber.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className={`w-8 h-8
            dark:bg-[#101010] ${digit ? "border-[#003478]" : "grey"}
            dark:border-[#4F4F4F] appearance-none border-2 rounded px-2 py-0.5
            dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black 
            text-base font-medium leading-tight focus:outline-none focus:shadow-outline input-main`}
                    />
                  ))}
                </div>

                {/* Save Button */}
                <button
                  disabled={!refNumber.every((digit) => digit !== "")}
                  onClick={(e) => {
                    e.preventDefault();
                    if (refNumber.length < 7) {
                      showToast("Please Enter Valid number", "error"); // Success toast
                      return;
                    }
                    setLoading(true);
                    handleAddRefNumber(e);
                  }}
                  className={`text-white text-sm rounded-full px-6 py-2 w-full md:w-auto ${
                    refNumber.every((digit) => digit !== "")
                      ? "bg-black"
                      : "bg-gray-300"
                  }`}
                >
                  Save
                </button>
              </div>

              <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                <span className="text-sm text-labelColour font-medium">
                  Advisor Name:
                </span>
                {isAdvisorExist && advisorName && (
                  <img src="/valid.svg" alt="User Icon" className="w-4 h-4" />
                )}
                {!isAdvisorExist && advisorName && (
                  <img src="/danger.svg" alt="User Icon" className="w-4 h-4" />
                )}
                <span
                  className={`text-sm ml-2 font-medium ${
                    isAdvisorExist
                      ? "text-black text-sm"
                      : "text-[#FF5050] text-xs"
                  }`}
                >
                  {advisorName}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white">
            <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* Profile Picture Section */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                <label
                  htmlFor="firstName"
                  className="block dark:text-gray-300 text-labelColour  color-test text-sm mb-1"
                >
                  Profile Picture <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <img
                      src={preview}
                      alt="Avatar"
                      className="w-14 h-14 rounded-full"
                    />
                  </div>
                  <div className="flex flex-col space-y-1">
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                    <button
                      onClick={handleUploadClick}
                      className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full"
                    >
                      Upload from Device
                    </button>
                    <button
                      onClick={startCamera}
                      className="bg-black text-white text-xs px-3 py-1 rounded-full flex items-center justify-center gap-2"
                    >
                      <img
                        src="/camera-black.svg"
                        alt="Camera Icon"
                        className="w-4 h-4"
                      />
                      Take Snap
                    </button>
                  </div>
                </div>
                {/* Fullscreen Camera Modal */}
                {showCamera && (
                  <div
                    className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${
                      animateCamera ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <div
                      className={`relative transform transition-transform duration-300 ease-in-out bg-white rounded-xl p-4 w-full max-w-md flex flex-col items-center ${
                        animateCamera ? "scale-100" : "scale-90"
                      }`}
                    >
                      {/* Preview or Live Camera */}
                      {preview === "" ? (
                        <video
                          ref={videoRef}
                          autoPlay
                          playsInline
                          className="w-full h-auto rounded shadow-lg"
                        />
                      ) : (
                        <div className="relative w-full">
                          <img
                            src={preview}
                            alt="Avatar"
                            className="w-full h-auto rounded shadow-lg"
                          />
                          <button
                            onClick={() => {
                              startCamera();
                            }}
                            className="absolute top-2 right-2 bg-white hover:bg-gray-100 p-1 rounded-full shadow-md transition"
                            aria-label="Remove preview"
                          >
                            <img
                              src="/trash.svg"
                              alt="Delete"
                              className="w-4 h-4"
                            />
                          </button>
                        </div>
                      )}

                      {/* Action Buttons */}
                      <div className="flex flex-wrap justify-center gap-4 mt-4">
                        <button
                          onClick={handleCloseCamera}
                          className="bg-white text-black border-black border-2 text-sm px-4 py-2 rounded-full"
                        >
                          Cancel
                        </button>
                        {preview === "" && (
                          <>
                            <button
                              onClick={handleTakeSnap}
                              className="bg-black text-white text-sm px-4 py-2 rounded-full"
                            >
                              Capture Photo
                            </button>
                          </>
                        )}
                        {preview !== "" && (
                          <>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                handleUploadFile(e);
                              }}
                              className="bg-black text-white text-sm px-4 py-2 rounded-full"
                            >
                              Upload Photo
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <canvas ref={canvasRef} className="hidden" />
                <div className="mt-4">
                  <label
                    htmlFor="firstName"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    First Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    value={firstName}
                    placeholder="Your First Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setfirstName(e.target.value)}
                  />
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                    First Name as per identification documentation
                  </p>
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="lastName"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Last Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="lastName"
                    name="lastName"
                    type="text"
                    value={lastName}
                    placeholder="Your Last Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                    Last Name as per identification documentation
                  </p>
                </div>{" "}
                <div className="mt-4">
                  <label
                    htmlFor="middleName"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Middle Name
                  </label>
                  <input
                    id="middleName"
                    name="middleName"
                    type="text"
                    value={middleName}
                    placeholder="Your Middle Name"
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setMiddleName(e.target.value)}
                  />
                </div>
                <div className="mt-4 flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  <label
                    htmlFor="investmentType"
                    className="text-sm text-labelColour flex items-center"
                  >
                    Is this your name from birth?
                    <span className="text-red-500">*</span>
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="birthName"
                        value="yes"
                        checked={nameFromBirth === "yes"}
                        onChange={handleNameFromBirth}
                        className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="birthName"
                        value="no"
                        checked={nameFromBirth === "no"}
                        onChange={handleNameFromBirth}
                        className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                <div className="">
                  <label className="block mb-1 mt-4 text-sm text-[#464646]">
                    Customer's Former Names(s)
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1 border rounded-md border-gray-300 p-2 flex flex-wrap gap-2">
                    {formerNames.map((formerName, index) => (
                      <div
                        key={index}
                        className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                      >
                        <span>{formerName}</span>
                        <button
                          type="button"
                          onClick={() => handleRemoveFormerName(index)}
                          className="ml-2 text-gray-700 hover:text-gray-700"
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                    <input
                      type="text"
                      value={newFormerName}
                      onChange={(e) => setFormerName(e.target.value)}
                      onKeyDown={handleAddFormerName}
                      placeholder="Add name"
                      className="border-none focus:outline-none flex-grow text-sm"
                    />
                  </div>
                </div>
              </div>

              {/* Date of Birth Section */}
              <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                <div>
                  <label className="block mb-1 w-full text-sm text-[#464646]">
                    Date Of Birth <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    value={Dob}
                    onChange={(e) => setDob(e.target.value)}
                    className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                  />
                </div>
                <div className="mt-4">
                  <Dropdown
                    label={
                      <>
                        Expected Investment Amount
                        <span className="text-red-500"> *</span>
                      </>
                    }
                    options={expectedAmountData}
                    onSelect={handleSelectInvestmentAmount}
                  />
                </div>

                <div className="mt-4">
                  <Dropdown
                    label={
                      <>
                        Default Investment Currency
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={currencyData}
                    search={true}
                    preselectedValue={preselectedcashCurrency}
                    onSelect={handleSelectToCurrency}
                    colorLabel=""
                  />
                </div>
                {countryCode == 233 && (
                  <div className="mt-4">
                    <label
                      htmlFor="middleName"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Social Security Number
                    </label>
                    <input
                      id="socialSecurityNumber"
                      name="socialSecurityNumber"
                      type="text"
                      value={socialSecurityNumber}
                      placeholder="Your Social Security Number"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setSocialSecurityNumber(e.target.value)}
                    />
                  </div>
                )}
              </div>

              {/* Client ID Section */}
              <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                <label
                  htmlFor="refId"
                  className="mb-1 text-sm text-labelColour"
                >
                  Client ID
                </label>
                <input
                  id="refId"
                  type="text"
                  value={clientId}
                  disabled={true}
                  className="bg-[#F9F9F9] p-2 text-black font-medium rounded-md text-md"
                  placeholder="INV1947534324"
                />
                <div className="mt-4">
                  <label
                    htmlFor="address"
                    className="block text-sm text-labelColour"
                  >
                    Residential Address <span className="text-red-500"> *</span>
                  </label>
                  <AddressAutocomplete
                    onSelect={(addr) => setRedAddress(addr)}
                  />
                </div>
                <p className="text-[10px] mt-1 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                  PLEASE MAKE SURE THE PROVIDED ADDRESS MATCHES THE DOCUMENT
                  PROOFS YOU PROVIDE.
                </p>

                {accountType != 1 && accountType != 5 && (
                  <>
                    <div className="mt-4">
                      <label
                        htmlFor="jAccId"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Joint Account ID<span className="text-red-500">*</span>
                      </label>
                      <input
                        id="jAccId"
                        name="jAccId"
                        type="text"
                        value={jointAccountId}
                        placeholder="Joint Account Id"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setJointAccountId(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col items-start mt-2 w-full max-w-md mx-auto ">
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          id="confirm-all"
                          className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#005A9C] checked:bg-[#005A9C] relative"
                          checked={isCheckedSecond}
                          onChange={(e) => setIsCheckedSecond(e.target.checked)}
                        />
                        <label
                          htmlFor="confirm-all"
                          className={`text-sm
                      ${isCheckedSecond ? "text-black" : "text-[#888888]"}
                      `}
                        >
                          Managing Member.
                        </label>
                      </div>
                      <p className="text-[10px] mt-1 text-[#363636] bg-[#FFC421] border-[#FFC421] bg-opacity-50 px-2 py-1 border-2 rounded-lg">
                        By clicking on this you agree to be contacted to manage
                        the account
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {accountType != 1 && accountType != 5 && (
          <div className="bg-white shadow-md rounded-md p-4 mt-4">
            {" "}
            <div className="flex justify-between font-medium items-center mb-4">
              <div className="flex flex-col">
                <h2 className="text-lg">Invite Joint Account Members</h2>
                {(members.length === 0 ||
                  (members.length > 0 &&
                    members[0].firstName === "" &&
                    members[0].lastName === "" &&
                    members[0].email === "")) && (
                  <div className="flex items-center space-x-1">
                    <img
                      src="/danger.svg"
                      alt="User Icon"
                      className="w-4 h-4"
                    />
                    <span className="text-xs ml-2 font-medium text-[#FF5050]">
                      It is mandatory to provide at least one invitee to the
                      Joint Account.
                    </span>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-1">
                <span className="text-sm text-labelColour">
                  No of Joint Account Member:{" "}
                </span>
                <span className="text-sm text-black">
                  {members.length.toString().padStart(2, "0")}
                </span>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                {/* Table Head */}
                <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                  <tr>
                    <th className="p-2 w-[40px]"></th>
                    <th className="p-2">First Name</th>
                    <th className="p-2">Last Name</th>
                    <th className="p-2">Date of Birth</th>
                    <th className="p-2">Email Address</th>
                    <th className="p-2">Mobile Number</th>
                    {accountType == 4 && (
                      <th className="p-2">Residential Address</th>
                    )}
                    {(accountType == 2 ||
                      accountType == 3 ||
                      accountType == 4) && (
                      <th className="p-2">Account Type</th>
                    )}
                    <th className="p-2 w-[40px]"></th>
                  </tr>
                </thead>

                {/* Table Body */}
                <tbody>
                  {members.map((member, idx) => (
                    <tr key={idx} className="border-t bg-white align-top">
                      {/* Index */}
                      <td className="p-2 font-medium text-labelColour">
                        {(idx + 1).toString().padStart(2, "0")}.
                      </td>

                      {/* First Name */}

                      <td className="p-2">
                        <input
                          className="border w-full p-2 rounded-xl text-sm"
                          placeholder="First Name"
                          value={member.firstName}
                          onChange={(e) =>
                            updateMember(idx, "firstName", e.target.value)
                          }
                        />
                      </td>
                      <td className="p-2">
                        <input
                          className="border w-full p-2 rounded-xl text-sm"
                          placeholder="Last Name"
                          value={member.lastName}
                          onChange={(e) =>
                            updateMember(idx, "lastName", e.target.value)
                          }
                        />
                      </td>
                      {/* DOB */}
                      <td className="p-2">
                        <input
                          type="date"
                          className="border w-full p-2 rounded-xl text-sm"
                          placeholder="Date of Birth"
                          value={member.dob}
                          onChange={(e) =>
                            updateMember(idx, "dob", e.target.value)
                          }
                        />
                      </td>

                      {/* Email */}
                      <td className="p-2">
                        <div className="flex flex-col">
                          <input
                            className={`border w-full p-2 rounded-xl text-sm ${
                              member.errors?.email ? "border-red-500" : ""
                            }`}
                            type="email"
                            placeholder="Email"
                            value={member.email}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                value
                              );
                              updateMember(idx, "email", value, {
                                ...member.errors,
                                email:
                                  isValid || value === ""
                                    ? ""
                                    : "Invalid email address",
                              });
                            }}
                          />
                          {member.errors?.email && (
                            <span className="text-red-500 text-xs mt-1">
                              {member.errors.email}
                            </span>
                          )}
                        </div>
                      </td>

                      {/* Mobile */}
                      <td className="p-2">
                        {" "}
                        <div className="flex flex-col">
                          {" "}
                          <div className="flex items-center border rounded-xl overflow-hidden">
                            {" "}
                            <select
                              className=" px-2 text-sm text-[#888888] font-medium bg-transparent outline-none"
                              value={member.countryCode}
                              onChange={(e) =>
                                updateMember(idx, "countryCode", e.target.value)
                              }
                            >
                              {" "}
                              {countries.map((c) => (
                                <option
                                  className=""
                                  key={c.code}
                                  value={c.dialCode}
                                >
                                  {" "}
                                  {c.code} ({c.dialCode}){" "}
                                </option>
                              ))}{" "}
                            </select>
                            <input
                              className={`outline-none p-2 text-sm w-full ${
                                member.errors?.mobile ? "border-red-500" : ""
                              }`}
                              placeholder="Mobile"
                              value={member.mobile}
                              onChange={(e) => {
                                const value = e.target.value;
                                const isValid = /^[0-9]{9}$/.test(value);
                                updateMember(idx, "mobile", value, {
                                  ...member.errors,
                                  mobile:
                                    isValid || value === ""
                                      ? ""
                                      : "Enter a valid 9-digit number",
                                });
                              }}
                            />
                          </div>
                          {member.errors?.mobile && (
                            <span className="text-red-500 text-xs mt-1">
                              {member.errors.mobile}
                            </span>
                          )}
                        </div>{" "}
                      </td>

                      {accountType == 4 && (
                        <td className="p-2">
                          <div className="flex flex-col">
                            <input
                              className={`border w-full p-2 rounded-xl text-sm ${
                                member.errors?.address ? "border-red-500" : ""
                              }`}
                              type="address"
                              placeholder="Address"
                              value={member.address}
                              onChange={(e) =>
                                updateMember(idx, "address", e.target.value)
                              }
                            />
                            {member.errors?.address && (
                              <span className="text-red-500 text-xs mt-1">
                                {member.errors.address}
                              </span>
                            )}
                          </div>
                        </td>
                      )}
                      {(accountType == 2 ||
                        accountType == 3 ||
                        accountType == 4) && (
                        <td className="p-2">
                          <div className="flex flex-col relative w-full">
                            <div className="mt-1 relative">
                              <select
                                className="w-full border pr-6 p-2 rounded-xl text-sm focus:outline-none bg-white appearance-none"
                                value={member.accountType}
                                onChange={(e) =>
                                  updateMember(
                                    idx,
                                    "accountType",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="individual">Individual</option>
                                <option value="corporate">Corporate</option>
                              </select>
                              <div className="pointer-events-none absolute inset-y-0 right-1 flex items-center">
                                <svg
                                  className="h-4 w-4 text-black"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M10 12a1 1 0 01-.7-.3l-3-3a1 1 0 111.4-1.4L10 9.6l2.3-2.3a1 1 0 011.4 1.4l-3 3a1 1 0 01-.7.3z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                            </div>
                            {member.errors?.accountType && (
                              <span className="text-red-500 text-xs mt-1">
                                {member.errors.accountType}
                              </span>
                            )}
                          </div>
                        </td>
                      )}
                      {/* Delete */}
                      <td className="p-2 text-center">
                        <button
                          onClick={() => removeMember(idx)}
                          title="Remove"
                          className="text-red-500"
                        >
                          <img
                            src="/trash.svg"
                            alt="Delete"
                            className="h-5 w-5"
                          />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="flex justify-center mt-4 w-full">
              <button
                onClick={addMember}
                className="text-[#005A9C] bg-white rounded-xl px-4 py-2 border-dashed border-2 text-sm"
              >
                + Add Joint Account Member
              </button>
            </div>
            {isUserPopOpen && (
              <AddUserPopup
                setactualData={setactualData}
                onClose={() => setisUserPopOpen(false)}
              />
            )}
            {members.length > 0 &&
              members[0].firstName !== "" &&
              members[0].lastName !== "" &&
              members[0].email !== "" && (
                <div className="mt-4 border-t grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  <div className="flex flex-col px-2 md:pl-4 md:pr-0 pt-4">
                    {/* Label and Question */}
                    <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                      <label
                        htmlFor="investmentType"
                        className="block text-sm text-labelColour whitespace-normal break-words"
                      >
                        Is there going to be a Sole Signatory by providing a
                        Power Of Attorney?
                        <span className="text-red-500">*</span>
                      </label>

                      {/* Radio Buttons */}
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="signatory"
                            value="yes"
                            checked={signatory === "yes"}
                            onChange={(e) => setSignatory(e.target.value)}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="signatory"
                            value="no"
                            checked={signatory === "no"}
                            onChange={(e) => setSignatory(e.target.value)}
                            className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelLightColour whitespace-normal break-words"
                      >
                        All the Joint Account members will be considered as
                        Signatories
                      </label>
                    </div>
                  </div>
                  {signatory == "yes" && (
                    <>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-2">
                        <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                          <div className="mb-2">
                            <Dropdown
                              label={
                                <>
                                  Select which joint account member is going to
                                  be the sole signatory
                                  <span className="text-red-500"> *</span>
                                </>
                              }
                              options={jointAccountUsersData}
                              preselectedValue={preselectedJointAccountUser}
                              onSelect={handleSelectJointAccountUser}
                            />
                          </div>{" "}
                        </div>
                      </div>
                      <div className="flex lg:pt-4 pt-0 flex-col px-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour flex items-center"
                          >
                            Power of Attorney
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            onChange={handleFileChangeAttorney}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileAttorney && fileAvailable && (
                          <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileAttorney.name}
                              </span>
                              <span className="text-[#46DA55] text-xs">
                                Upload Completed
                              </span>
                            </div>
                            <button
                              onClick={handleDeleteFile}
                              className="text-red-500 flex-shrink-0 font-semibold"
                            >
                              <img
                                src="/trash.svg"
                                alt="Success Icon"
                                className="h-4 w-4 flex-shrink-0"
                              />
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
          </div>
        )}
      </div>
      <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
          {/* Save as Draft */}
          <button
            onClick={() => {}}
            className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
          >
            <span>Save as Draft</span>
          </button>

          <ConfirmContinueButton
            onContinue={handleContinue}
            buttonText="Continue"
            confirmTitle="Save Section"
            confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
          />
        </div>
      </footer>
    </div>
  );
};

export default PersonalInfo;
